import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatErr, fmtDate } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import OrganizationInbox from "@/components/messaging/OrganizationInbox";

export default function AdminMessages() {
  const [rows, setRows] = useState([]);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/school/messages").then((r) => setRows(r.data)).catch((e) => toast.error(formatErr(e)));
  }, []);

  return (
    <div data-testid="admin-messages">
      <div className="mb-6">
        <h1 className="font-heading text-2xl font-extrabold">Communication Activity</h1>
        <p className="text-sm text-slate-500 mt-1">Audit view of one-way teacher → parent messages in your school.</p>
      </div>

      <div className="hidden lg:block bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F5F7] text-left text-xs text-slate-500 uppercase tracking-wide">
            <tr>
              <th className="px-5 py-3">Date</th><th className="px-5 py-3">Teacher</th><th className="px-5 py-3">Student</th><th className="px-5 py-3">Class</th><th className="px-5 py-3">Subject</th><th className="px-5 py-3">Parent</th><th className="px-5 py-3">Purpose</th><th className="px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} data-testid={`am-row-${m.id}`} onClick={() => setDetail(m)} className="border-t border-slate-100 cursor-pointer hover:bg-[#F4F5F7]/60 transition-colors duration-200">
                <td className="px-5 py-3 text-slate-500 whitespace-nowrap">{fmtDate(m.created_at)}</td>
                <td className="px-5 py-3 font-semibold">{m.teacher_name}</td>
                <td className="px-5 py-3">{m.student_name}</td>
                <td className="px-5 py-3">{m.class_name}</td>
                <td className="px-5 py-3">{m.subject_name || "—"}</td>
                <td className="px-5 py-3">{m.parent_name}</td>
                <td className="px-5 py-3">{m.purpose}</td>
                <td className="px-5 py-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${m.is_read ? "bg-status-green/10 text-status-green" : "bg-slate-100 text-slate-400"}`}>{m.is_read ? "Read" : "Unread"}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <p className="text-sm text-slate-400 py-10 text-center">No teacher → parent messages yet.</p>}
      </div>

      <div className="lg:hidden space-y-3" data-testid="am-cards">
        {rows.map((m) => (
          <button key={m.id} data-testid={`am-card-${m.id}`} onClick={() => setDetail(m)} className="w-full text-left bg-white border border-slate-200 rounded-2xl p-4">
            <div className="flex items-center justify-between gap-2">
              <p className="font-heading font-bold truncate">{m.student_name}</p>
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full shrink-0 ${m.is_read ? "bg-status-green/10 text-status-green" : "bg-slate-100 text-slate-400"}`}>{m.is_read ? "Read" : "Unread"}</span>
            </div>
            <p className="text-xs text-slate-500 mt-1">{m.teacher_name} → {m.parent_name} · {m.class_name}{m.subject_name ? ` · ${m.subject_name}` : ""}</p>
            <p className="text-xs text-slate-400 mt-1">{m.purpose} · {fmtDate(m.created_at)}</p>
          </button>
        ))}
        {rows.length === 0 && <p className="text-sm text-slate-400 py-8 text-center">No teacher → parent messages yet.</p>}
      </div>

      <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
        <DialogContent className="rounded-2xl" data-testid="am-detail">
          {detail && (
            <>
              <DialogHeader><DialogTitle className="font-heading">Message detail</DialogTitle></DialogHeader>
              <div className="space-y-2 text-sm">
                <p><span className="text-slate-400">From:</span> <span className="font-semibold">{detail.teacher_name}</span></p>
                <p><span className="text-slate-400">To parent:</span> <span className="font-semibold">{detail.parent_name}</span></p>
                <p><span className="text-slate-400">Student:</span> {detail.student_name} · {detail.class_name}{detail.subject_name ? ` · ${detail.subject_name}` : ""}</p>
                <p><span className="text-slate-400">Purpose:</span> {detail.purpose} · <span className="text-slate-400">Sent:</span> {fmtDate(detail.created_at)}</p>
                <p><span className="text-slate-400">Status:</span> {detail.is_read ? `Read ${fmtDate(detail.read_at)}` : "Unread"}</p>
                <div className="bg-[#F4F5F7] rounded-xl p-4 whitespace-pre-wrap text-slate-700 mt-2">{detail.message}</div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
      <div className="mt-8 border-t pt-8"><OrganizationInbox staff /></div>
    </div>
  );
}
